import Icon, { GenericIconProps } from '../Icon';

const LocationIcon: React.FC<GenericIconProps> = ({ className }) => {
  const svg = {
    viewBox: '0 0 14 20',
  };

  const path = [
    {
      // eslint-disable-next-line max-len
      d: 'M6.79402 0.833328C5.08056 0.833673 3.43737 1.5145 2.22577 2.7261C1.01417 3.9377 0.333353 5.58088 0.333008 7.29434C0.333008 12.0864 6.79402 19.3917 6.79402 19.3917C6.79402 19.3917 13.255 12.0838 13.255 7.29434C13.2547 5.58088 12.5739 3.9377 11.3623 2.7261C10.1507 1.5145 8.50748 0.833673 6.79402 0.833328ZM6.79402 10.0208C6.25375 10.0208 5.72562 9.86058 5.2764 9.56042C4.82718 9.26026 4.47705 8.83364 4.2703 8.3345C4.06355 7.83535 4.00946 7.28611 4.11486 6.75622C4.22026 6.22633 4.48042 5.73959 4.86245 5.35756C5.24448 4.97553 5.73121 4.71537 6.2611 4.60997C6.79099 4.50457 7.34023 4.55867 7.83938 4.76542C8.33852 4.97217 8.76515 5.32229 9.06531 5.77151C9.36547 6.22073 9.52567 6.74886 9.52567 7.28913C9.52567 8.01361 9.23788 8.70842 8.72559 9.2207C8.21331 9.73299 7.5185 10.0208 6.79402 10.0208Z',
    },
  ];

  return <Icon className={className} svg={svg} path={path} />;
};

export default LocationIcon;
